import { redirect } from "react-router-dom";

export default function Dashboard(props: any) {
  redirect('/devices')
  return (
    <div className="container mx-auto">
      <h1>Dashboard</h1>
    </div>
  )
}